/**
 * Dashboard de Puntos (GET /bo/points/metrics). Tipos camelCase del DTO del backend.
 *
 * null en las tasas y promedios = "no se puede calcular" (no es 0): la pantalla lo muestra como "—".
 */

export type PointHealthStatus = "go" | "warn" | "no_go";

export interface PointMetricsRange {
  /** YYYY-MM-DD, día calendario en hora AR. */
  from: string;
  /** YYYY-MM-DD, inclusive. */
  to: string;
}

export interface PointMetricsEmission {
  pointsIssued: number;
  pointsRedeemed: number;
  pointsRefunded: number;
}

export interface PointMetricsRedemptions {
  pending: number;
  expired: number;
  fulfilled: number;
  cancelled: number;
  validatedUnder48hRate: number | null;
  pendingValidation: number;
}

export interface PointMetricsEngagement {
  usersWithBalance: number;
  activeUsers: number;
  balanceAdoptionRate: number | null;
  averageActiveStreak: number | null;
  usersWithActiveStreak: number;
}

export interface PointMetricsPenalties {
  noShowCount: number;
  pointsDeducted: number;
}

export interface PointMetricsHealthCheck {
  key: string;
  value: number;
  threshold: number;
  status: string;
}

export interface PointMetricsHealth {
  status: PointHealthStatus | null;
  checks: PointMetricsHealthCheck[];
}

export interface PointMetricsWeek {
  /** YYYY-MM-DD: primer día de la semana. */
  weekStart: string;
  pointsIssued: number;
  pointsRedeemed: number;
}

export interface PointMetrics {
  tenantId: string | null;
  range: PointMetricsRange;
  emission: PointMetricsEmission;
  redemptions: PointMetricsRedemptions;
  engagement: PointMetricsEngagement;
  penalties: PointMetricsPenalties;
  weeklySeries: PointMetricsWeek[];
  health: PointMetricsHealth;
}

/** Lo que el ticket llama "Canjes": todos los estados de canje juntos. */
export const countPointRedemptions = (m: PointMetrics): number =>
  m.redemptions.pending + m.redemptions.expired + m.redemptions.fulfilled + m.redemptions.cancelled;

/** Entero con separador de miles es-AR: 12500 → "12.500". */
export const formatMetricInteger = (n: number): string => n.toLocaleString("es-AR");
